<template>
  <section class="news">
    <section class="news-container-left news-wrap">
      <!-- <top-news :topdata="topdata"></top-news> -->
      <news-list
        :NewsLabel="NewsLabel"
        :nordata="nordata"
        :stockCodeList="stockCodeList"
        @getMoreNews="getMoreNews"
        @getTagNews="getTagNews"
        :newsType="newsType"
        :typeValue="typeValue"
      ></news-list>
      <!-- <nor-news :nordata='nordata' @getMoreNews="getMoreNews"></nor-news> -->
    </section>
    <section class="news-container-right">
      <!-- <dtb-sidebar></dtb-sidebar> -->
      <infiniteDtb></infiniteDtb>
      <hotArticle class="hotArticle"></hotArticle>
    </section>
    <p style="clear:both"></p>
  </section>
</template>

<script>
import topNews from "~/components/news/top-news";
import norNews from "~/components/news/nor-news";
import newsList from "~/components/news/news-list";
// import dtbSidebar from '~/components/public/live-sidebar'
import infiniteDtb from "~/components/public/infinite-dtb.vue";
import hotArticle from "~/components/public/hot-article.vue";
import * as api from "~/api/index";

export default {
  async asyncData({ params, query, route, error, app, $axios }) {
    try {
      let allTypes = {
        'announcement': 27,
        'linerating': 28,
        'performance': 30,
        'hkstockchange': 32,
        'companyInfo': 33,
        'marketmacro': 36,
        'newstock': 37
      }

      let zhTypes = {
        'announcement': '公告摘要',
        'linerating': '大行评级',
        'performance': '业绩直击',
        'hkstockchange': '港股异动',
        'companyInfo': '公司信息',
        'marketmacro': '市场宏观',
        'newstock': '新股速递'
      }
      //获取类型
      let newsType = query.type
      let zhTypeName = zhTypes[newsType]
      let [nordata, NewsLabel] = await Promise.all([
        $axios(
          api.getNews({
            createDate: "",
            count: 15,
            type: allTypes[newsType] ? allTypes[newsType] : ""
          })
        ),
        $axios(api.getNewsLabel())
      ])
      let stockList = []
      // 通过列表获取股票列表
      if (nordata && nordata.result && nordata.result.length > 0) {
        nordata.result.forEach((item, index) => {
          if (item.stocks) {
            item.stocks.forEach(e => {
              stockList = e.stockCode + "," + stockList;
            });
          }
        });
      } else {
        nordata = {
          result: []
        };
      }

      //获取股票列表详细数据
      let stockCodeList = await $axios(
        api.stockGains({
          stockCodes: stockList.slice(0, stockList.length - 1)
        })
      );

      //遍历重写列表数据
      nordata.result.forEach(items => {
        if (items.stocks) {
          items.stocks.forEach(ele => {
            stockCodeList.result.forEach(tags => {
              if (tags.market.toLowerCase() + tags.code === ele.stockCode) {
                ele.netChange = tags.netChange;
              }
            });
          });
        }
      });
      return {
        zhTypeName: zhTypeName,
        newsType: newsType,
        typeValue: allTypes[newsType] ? allTypes[newsType] : "",
        NewsLabel: NewsLabel.result,
        nordata: nordata.result,
        stockCodeList: stockCodeList.result
      };
      // getNewsLabel()
    } catch (err) {
      console.log(err);
      error({
        statusCode: 404,
        message: "文章不存在"
      });
    }
  },
  data() {
    return {};
  },
  methods: {
    async getTagNews(i) {
      this.nordata = [];
      let stockList = "";
      let result = await this.$axios(
        api.getNews({
          createDate: "",
          count: 15,
          type: i
        })
      );
      result.result.forEach(item => {
        if (item.stocks) {
          item.stocks.forEach(e => {
            stockList = e.stockCode + "," + stockList;
          });
        }
      });
      let StockLists = await this.$axios(
        api.stockGains({
          stockCodes: stockList.slice(0, stockList.length - 1)
        })
      );
      let stockCodeList = StockLists.result;
      result.result.forEach(items => {
        if (items.stocks) {
          items.stocks.forEach(ele => {
            stockCodeList.forEach(tags => {
              if (tags.market.toLowerCase() + tags.code === ele.stockCode) {
                ele.netChange = tags.netChange;
              }
            });
          });
        }
      });
      this.nordata = result.result;
    },
    async getMoreNews(i) {
      let createdTime = this.nordata[this.nordata.length - 1].createDate;
      let stockList = "";
      let results = await this.$axios(
        api.getNews({
          createDate: createdTime,
          count: 15,
          type: i
        })
      );
      results.result.forEach(item => {
        if (item.stocks) {
          item.stocks.forEach(e => {
            stockList = e.stockCode + "," + stockList;
          });
        }
      });
      let StockLists = await this.$axios(
        api.stockGains({
          stockCodes: stockList.slice(0, stockList.length - 1)
        })
      );
      let stockCodeList = StockLists.result;
      results.result.forEach(items => {
        if (items.stocks) {
          items.stocks.forEach(ele => {
            stockCodeList.forEach(tags => {
              if (tags.market.toLowerCase() + tags.code === ele.stockCode) {
                ele.netChange = tags.netChange;
              }
            });
          });
        }
      });
      this.nordata = [...this.nordata, ...results.result];
    }
  },
  mounted() { },
  layout: "news",
  components: {
    topNews,
    norNews,
    infiniteDtb,
    newsList,
    hotArticle
  },
  head() {
    return {
      title: this.newsType ? `${this.zhTypeName}_外汇实时查询_数据监控_市场分析-格隆汇` : '欧洲股市行情_港股异动_新股怎样申购_申购股票-格隆汇',
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.newsType ? `格隆汇事件栏目下具体介绍了金融行业内${this.zhTypeName}、行业评级、外汇数据监控、外汇市场分析等, 如果有对此感兴趣的人可到格隆汇官网查看, 因为站内更详细的展开了剖析.` : '格隆汇事件栏目下对欧洲股市行情, 港股异动, 新股怎样申购, 申购股票等相关内容进行了客观的监控及介绍, 要了解详细内容 的请到格隆汇官网进行查阅.'
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.newsType ? `${this.zhTypeName},外汇实时查询,外汇数据监控,外汇市场分析` : '欧洲股市行情,港股异动,新股怎样申购,申购股票'
        }
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.gelonghui.com/news/"
        },
        {
          rel: "alternate",
          media: "only screen and (max-width:640px)",
          href: "https://m.gelonghui.com/news/"
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.news {
  width: 1200px;
  min-height: 500px;
  margin: auto;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  _zoom: 1;

  .news-wrap {
    width: 852px;
    position: relative;
    margin-top: 10px;
    clear: both;
  }

  .news-container-right {
    width: 300px;
    margin-top: 10px;

    .hotArticle {
      margin: 20px 0;
    }
  }
}
</style>
